require('./bootstrap');

require('alpinejs');

require('./ckeditor');

import flatpickr from "flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js";

flatpickr.localize(Russian);
